import React from "react";
import store from "../../../Store";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toggleOrganizationUserListFilter } from "./UserList-Actions";
import { unslufigy } from "../../../helpers/StringHelper";
import { Link } from "react-router-dom";
import Button from "../../../components/shared/buttons/Button";

class OrganizationUserListFilters extends React.Component {
  componentDidMount() {}

  toggleFilter = (e) => {
    store.dispatch(toggleOrganizationUserListFilter(e));
  };

  render() {
    let { title, params, organization_id } = this.props;

    return (
      <div className="heading-block pr-60">
        <div className="title-block">
          <h2>{unslufigy(title)}</h2>
          <span>
            {" "}
            <Link to="/organizations">Organizations</Link>
          </span>
          <span>Users</span>
        </div>
        <div className="search-bar">
          <input
            type="text"
            className="form-control"
            name="q"
            placeholder={`Search ${unslufigy(title)}`}
            value={params.q}
            onChange={this.toggleFilter}
          />
          <span className="icon-search" />
        </div>

        <div className="button-wrapper">
          <Link to={`/organizations/${organization_id}/users/create`}>
            <Button
              className="btn-theme btn-dark-blue"
              title={`Add User`}
              text={`Add User`}
            />
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let {
    getOrganizationUsers,
    organizationUserList,
    getOrganization,
    organizationDashboard,
  } = state;
  let { params } = organizationUserList.data;
  let org_id =
    organizationDashboard &&
    organizationDashboard.data &&
    organizationDashboard.data.organization_id;

  return {
    getOrganizationUsers,
    params,
    getOrganization,
    org_id,
    organizationDashboard,
  };
}
export default withRouter(
  connect(mapStateToProps)(OrganizationUserListFilters)
);
